import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { clientHeaders } from "@constants/headers";
import { getOrCreateDeviceId, getToken, removeToken, TokenType } from "@cpj-ai/panel-npm-package";
import ApolloLinkTimeout from "apollo-link-timeout";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";

const timeoutLink = new ApolloLinkTimeout(100000);

const apolloClientProps = {
  uri: import.meta.env.VITE_PUBLIC_API_URL,
  cache: new InMemoryCache(),
  connectToDevTools: true,
};

const _apolloClient = new ApolloClient(apolloClientProps);

const authLink = setContext(async (_, { headers }) => {
  const authToken = await getToken(_apolloClient, TokenType.ADMIN_AUTH);
  if (authToken) {
    return {
      headers: {
        ...headers,
        Authorization: `${clientHeaders.jwtPrefix} ${authToken.token}`,
        [clientHeaders.deviceId]: getOrCreateDeviceId(),
      },
    };
  }
  return {
    headers: {
      ...headers,
      [clientHeaders.deviceId]: getOrCreateDeviceId(),
    },
  };
});

const errorLink = onError(({ networkError }) => {
  if (networkError && "statusCode" in networkError) {
    switch (networkError.statusCode) {
      case 403:
        removeToken(TokenType.ADMIN_AUTH);
        window.location.reload();
        break;
      default:
        break;
    }
  }
});

const uploadLink = createUploadLink({
  uri: import.meta.env.VITE_PUBLIC_API_URL,
  credentials: "same-origin",
});

const createApolloClient = (cache = {}) => {
  return new ApolloClient({
    ...apolloClientProps,
    cache: new InMemoryCache().restore(cache),
    link: ApolloLink.from([authLink, errorLink, timeoutLink, uploadLink]),
  });
};

const apolloClient = createApolloClient();

export default apolloClient;
